import React from 'react';

const SearchAppContext = React.createContext({
  searchedQueue: '',
  searchedApp: '',
});

export default SearchAppContext;